import type { SearchResult } from '@powerful/data';

export const PUBLIC_FEED_CACHE_KEY = 'powerful.discovery.public-feed.v1';
export const PUBLIC_FEED_TTL_MS = 24 * 60 * 60 * 1000;

/** Lista explícita: nunca serializar o objeto inteiro da Edge (`isFavorite` é pessoal). */
export interface PublicFeedBusiness {
  id: string;
  slug: string;
  name: string;
  city: string | null;
  categoryId: string | null;
  coverUrl: string | null;
  logoUrl: string | null;
  ratingAvg: number;
  ratingCount: number;
  minPriceCents: number | null;
  bookingEnabled: boolean;
  sealStatus: string;
  badges: string[];
}
export interface PublicFeedSnapshot { savedAt: number; businesses: PublicFeedBusiness[] }

export function sanitizePublicResults(results: SearchResult[]): PublicFeedBusiness[] {
  return results.slice(0, 20).map(({ business }) => ({
    id: business.id,
    slug: business.slug,
    name: business.name,
    city: business.city,
    categoryId: business.categoryId,
    coverUrl: business.coverUrl,
    logoUrl: business.logoUrl,
    ratingAvg: business.ratingAvg,
    ratingCount: business.ratingCount,
    minPriceCents: business.minPriceCents,
    bookingEnabled: business.bookingEnabled,
    sealStatus: business.sealStatus,
    badges: [...business.badges],
  }));
}

export function savePublicFeed(results: SearchResult[], storage: Pick<Storage, 'setItem'> = localStorage, now = Date.now()): void {
  try { storage.setItem(PUBLIC_FEED_CACHE_KEY, JSON.stringify({ savedAt: now, businesses: sanitizePublicResults(results) })); } catch { /* storage opcional */ }
}

export function readPublicFeed(storage: Pick<Storage, 'getItem'> = localStorage, now = Date.now()): PublicFeedSnapshot | null {
  try {
    const raw = storage.getItem(PUBLIC_FEED_CACHE_KEY);
    if (!raw) return null;
    const value: unknown = JSON.parse(raw);
    if (!value || typeof value !== 'object' || !('savedAt' in value) || !('businesses' in value) || typeof value.savedAt !== 'number' || value.savedAt > now || now - value.savedAt > PUBLIC_FEED_TTL_MS || !Array.isArray(value.businesses)) return null;
    if (value.businesses.length > 20 || !value.businesses.every((b: unknown) => b && typeof b === 'object' && 'id' in b && typeof b.id === 'string' && 'slug' in b && typeof b.slug === 'string' && 'name' in b && typeof b.name === 'string' && !('isFavorite' in b) && !('origin' in b))) return null;
    return value as PublicFeedSnapshot;
  } catch { return null; }
}
